import { render, staticRenderFns } from "./Seventh.vue?vue&type=template&id=a8a742ae&"
import script from "./Seventh.vue?vue&type=script&lang=ts&"
export * from "./Seventh.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports